import useAsync from 'react-use/lib/useAsync';
import { httpClient } from '@alfa-bank/site-http-client';

import type { ICityByUserIPResponse } from '../model/http';
import { cityByIPEndPoint } from '../config';
import { UNKNOWN_FIAS_ID } from '../../config';

export function useAutoDetectFiasId() {
    const response = useAsync(async () => {
        try {
            const {
                data: { fiasId },
            } = await httpClient.get<ICityByUserIPResponse>(cityByIPEndPoint);

            return fiasId;
        } catch {
            return UNKNOWN_FIAS_ID;
        }
    }, []);

    return response.value ?? null;
}
